<cc-settings-block>
  <cc-settings-header
    header="PHONE.PRIORITY.HEADER"></cc-settings-header>
  <cc-settings-body>
    <div
      translate
      class="grey-text m-r-lg sm-down-m-b-sm">PHONE.PRIORITY.TABLE_HEADER
    </div>
    <mat-select
      [value]="selectedPriority"
      (selectionChange)="onSelectPriority($event)"
      [placeholder]="'CHOOSE' | translate">
      <mat-option
        *ngFor="let priority of priorityList"
        [value]="priority">
        {{priority.name}}
      </mat-option>
    </mat-select>
  </cc-settings-body>
</cc-settings-block>
